import { render } from "./SectionHeader.vue?vue&type=template&id=74145d18&scoped=true"
import script from "./SectionHeader.vue?vue&type=script&lang=js"
export * from "./SectionHeader.vue?vue&type=script&lang=js"

import "./SectionHeader.vue?vue&type=style&index=0&id=74145d18&lang=scss&scoped=true"
import "./SectionHeader.vue?vue&type=style&index=1&id=74145d18&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74145d18"]])

export default __exports__